<template>
  <div id="cabout">
    <h3>关于我们</h3>
    <div class="cabout_con">
      <p>我们告别了周而复始的效果图制作，回归到不加班 ·不熬夜 ·少改图 · 周末自由行的日子。得益于短时间内找到合适且复用的素材，有效地缩短了制图周期和提高了制图品质 ，做到了真正意义上的事半功倍，让我们更有价值！</p>
      <p>因为我们开发了这款插件，以针对性解决问题为目的。现开放出来，供各位同仁使用、甄别、欢迎拍砖。</p>
      <p>为了拓展插件，让制图更加高效，我们开发建立了图艺模块库网站，宗旨在于建立可以让大家共同上传、分享、共用、共赢的一个平台。如有好的意见、建议欢迎加客服QQ好友:389811573。<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=2787215109&site=qq&menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:2787215109:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
      <p class="cabout_jr">或者，您如果有更好的发展愿景，欢迎联系我们，加入我们，谢谢！</p>

    </div>
  </div>
</template>

<script>

export default {
  name:'cabout',
  data() {
    return {

    }
  },
  props:{
    
  },
  computed: {
    
  },
  components:{
    
  },
  methods: {
    
  },
}
</script>

<style>
#cabout{
  width: 100%;
  padding: 25px 35px 25px 195px;
  color: rgb(53, 61, 68);
}
#cabout > h3{
  padding: 15px 0;
  margin: 0;
  border-bottom: 1px solid #e6e6e6;
}
.cabout_con{
  width: 700px;
}
.cabout_con > p{
  text-indent: 2em;
  line-height: 30px;
  font-size: 15px;
  font-weight: bold;
  color: rgb(91, 98, 104);
}
.cabout_con >.cabout_jr{
  color: rgb(27, 31, 34);
}
</style>